import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Loader2, Puzzle } from "lucide-react";
import { API, getAuthHeaders } from "@/App";

export default function MiniAppPickerDialog({ open, onOpenChange, conversationId }) {
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sending, setSending] = useState(null);

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    fetch(`${API}/mini-apps`, { credentials: "include", headers: getAuthHeaders() })
      .then((r) => (r.ok ? r.json() : []))
      .then(setApps)
      .finally(() => setLoading(false));
  }, [open]);

  const send = async (app_id) => {
    if (!conversationId) return;
    setSending(app_id);
    try {
      const res = await fetch(`${API}/mini-apps/${app_id}/send`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json", ...getAuthHeaders() },
        body: JSON.stringify({ conversation_id: conversationId }),
      });
      if (!res.ok) throw new Error();
      onOpenChange(false);
    } catch {
      toast.error("No se pudo enviar");
    } finally {
      setSending(null);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#17212b] border-[#232e3c] text-white sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Puzzle className="w-5 h-5 text-purple-400" /> Mini-apps
          </DialogTitle>
          <DialogDescription className="text-slate-400">
            Comparte una mini-app interactiva en este chat.
          </DialogDescription>
        </DialogHeader>

        {loading ? (
          <div className="flex justify-center py-8"><Loader2 className="w-6 h-6 animate-spin text-purple-400" /></div>
        ) : (
          <div className="grid grid-cols-2 gap-2">
            {apps.map((a) => (
              <button
                key={a.app_id}
                onClick={() => send(a.app_id)}
                disabled={sending === a.app_id}
                className="flex flex-col items-start p-3 rounded-lg bg-[#0e1621] border border-[#232e3c] hover:border-purple-500 text-left transition"
              >
                <div className="text-2xl mb-1">{a.icon || "📲"}</div>
                <div className="text-sm font-semibold">{a.name}</div>
                <div className="text-xs text-slate-400 line-clamp-2">{a.description}</div>
              </button>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
